import React from "react";
import { Button } from "./Button";

interface Props {
  errorMessageTitle: string;
  errorMessage: string;
  onClose?: () => void;
  maxWidth?: number;
}

export const ErrorMessageModal: React.FC<Props> = ({
  errorMessageTitle,
  errorMessage,
  onClose,
  maxWidth,
}) => {
  return (
    <>
      {errorMessageTitle && errorMessage ? (
        <>
          <div className="z-[5000] fixed right-0 left-0 top-0 bottom-0 bg-black opacity-[0.5]"></div>
          <div className="z-[5001] fixed inset-0 flex justify-center items-center">
            <div className="relative p-[25.2496px] mx-10 rounded-[12px] bg-white max-w-[24.5rem]">
              <div
                style={{ maxWidth: maxWidth ? maxWidth : 0, width: maxWidth ? "65vw" : "auto" }}
              ></div>
              <button
                onClick={onClose}
                className="absolute top-[25.2496px] right-[25.2496px] text-black hover:text-[#313131]"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <div className="py-[2.1875rem] flex flex-col items-center">
                <img
                  className="w-[1rem] mb-[8.33px]"
                  alt="아래 화살표 아이콘"
                  src="/assets/icons/alerticon.svg"
                />
                <div className="font-bold mb-[1.25rem] text-[#555555]">
                  {errorMessageTitle}
                </div>
                <div className="font-medium text-[#555555]">{errorMessage}</div>
              </div>

              <div>
                <Button
                  type="submit"
                  loading={false}
                  onClick={onClose}
                  className="w-full h-[3rem] rounded-[0.5rem] text-[1rem] bg-blue-600 hover:bg-blue-700 text-white font-['Pretendard'] font-semibold transition-colors"
                >
                  확인
                </Button>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
